import { Link } from "gatsby";
import React from "react"
import { Accordion, Container } from 'react-bootstrap';


const Faqs = ({
  sectionClass = 'bg-white',
  accordian
}) => {
  return (
    <section className={`section ${sectionClass}`}>
      <Container className="py-5">
        <div className="mb-5 pb-1">
          <h2 className="mb-0">
            Frequently asked <span className="text-primary">questions</span>
          </h2>
        </div>
        <Accordion defaultActiveKey="0" className="accordion-dark-box" flush>
          {
            accordian.map((item, index) => (
              <Accordion.Item eventKey={index.toString()} key={index}>
                <Accordion.Header>{item.title}</Accordion.Header>
                <>
                  {
                    item.datalist === "datalist" ?
                      <Accordion.Body>
                        {
                          item?.data?.map((innerItem, index) => (
                            <>
                              <h4 className="h5">{innerItem.datatitle}</h4>
                              <p className={`lead${index === item.data.length - 1 ? ' mb-0' : ' mb-4'}`}>{innerItem.datadescript}</p>
                            </>
                          ))
                        }
                      </Accordion.Body> :
                      null
                  }
                  {
                    item.keyname === "list" ?
                      <Accordion.Body>
                        {
                          item.seckey === "para" ?
                            <p dangerouslySetInnerHTML={{ __html: item.paragraph }} /> :
                            null
                        }
                        <ul className="bullet-list">
                          {
                            item?.list?.map((item, index) => (
                              <li key={index} dangerouslySetInnerHTML={{ __html: item.list1 }} />
                            ))
                          }
                        </ul>

                        {
                          item.seckey === "para" ?
                            <>
                              {
                                item.paragraph2 ?
                                  < p >{item.paragraph2}</p> :
                                  null
                              }
                            </> :
                            null
                        }

                        {
                          item.footerdes ?
                            <>
                              <p>{item.paragraphnew}</p>
                            </> :
                            null
                        }
                      </Accordion.Body>


                      :
                      <Accordion.Body>
                        <p dangerouslySetInnerHTML={{ __html: item.des }}></p>
                      </Accordion.Body>
                  }
                </>
              </Accordion.Item>
            ))
          }
        </Accordion>
        <div className="pt-5 text-center">
          <p className="mb-0 font-size-22">Have more questions?</p>
          <Link to="/request-quote.html" className="btn btn-link px-0">
            <span>Ask our experts</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
          </Link>
        </div>
      </Container>
    </section >
  )
}

export default Faqs;
